var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qx-card',{attrs:{"title":"列表"}},[_c('section',{staticClass:"tablePage"},[_c('section',{ref:"tableBox",staticClass:"tableBox"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableData.loading),expression:"tableData.loading"}],ref:"multipleTable",attrs:{"data":_vm.tableData.data,"tooltip-effect":"dark","height":_vm.tableHeight},on:{"select":_vm.handleSelectionChange,"select-all":_vm.handleSelectionChange}},[_vm._l((_vm.tableData.title),function(item,index,key){return _c('el-table-column',{key:key,attrs:{"prop":item.prop,"label":item.label,"sortable":item.sortable,"filters":item.filters,"filter-method":item.filterHandler,"min-width":item.minW,"width":item.w},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _c('section',{},[(scope.column.property === 'attachTenantName')?_c('section',{on:{"click":function($event){return _vm.toTenantDetail(scope.row)}}},[_c('span',{staticClass:"primary cur"},[_vm._v("\n                "+_vm._s(scope.row[scope.column.property])+"\n              ")])]):_c('section',[_vm._v(_vm._s(scope.row[scope.column.property]))])])}}],null,true)})}),_c('el-table-column',{attrs:{"prop":"control","label":"操作","width":"180","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('TableBtn',{attrs:{"tableData":scope.row,"btnList":[
                //  {
                //   permpisions: '1002020201',
                //   showCondition: scope.row.stateName === '处理中',
                //   // showCondition:true,
                //   name: '审核',
                //   event: () => toApprove(scope.row,'approve'),
                // },
                {
                  showCondition: scope.row.isAuth === 1 && scope.row.state!==1,
                  name: '审核',
                  event: function () { return _vm.toApprove(scope.row,'approve'); },
                },
                // {
                //   permpisions: '1400106',
                //   showCondition:
                //     scope.row.applyCarUserType !== 1 &&
                //     scope.row.state === 2 &&
                //     !scope.row.newApplyId,
                //   name: '再次邀请',
                //   event: () => toEdit(scope.row.id, 1),
                // },
                //此处有bug需要处理，先暂时隐藏，可操作重新新增步骤
                // {
                //   permpisions: '',
                //   showCondition:
                //     scope.row.applyCarUserType === 1 &&
                //     scope.row.state === 2 &&
                //     !scope.row.newApplyId,
                //   name: '再次申请',
                //   event: () => toEdit(scope.row.id, 2),
                // },
                {
                  permpisions: '1400107',
                  showCondition:
                    scope.row.applyCarUserType === 1 &&
                    scope.row.state === 2 &&
                    !scope.row.newApplyId &&
                    scope.row.beApplyTenantId !== -1,
                  name: '申请平台仲裁',
                  event: function () { return _vm.toEdit(scope.row.id, 3); },
                } ]}})]}}])})],2)],1),_c('section',{staticClass:"paginationBox clearPa"},[_c('section',{staticClass:"right"},[_c('el-pagination',{attrs:{"current-page":_vm.tableData.page,"page-sizes":[10, 20, 50],"page-size":_vm.tableData.count,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.tableData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }